// SWEDISH localisation file for default keys

import React, { Fragment } from 'react';

export const keys = (v = {}) => ({
  // Customized strings for different markets - these will override the default STRINGS
  MARKET_STRINGS: {
    // Sweden
    SE: {},

    // Norway
    NO: {},

    // Finland
    FI: {
      platform_email: "asiakaspalvelu@jool.fi",
      ssn_placeholder: "ddmmyyczzzq",
      bank_transfer_bankgiro: "Banköverföring",
      ssn_validation_error: "Felaktigt personnummer (DDMMYYCZZZQ)",
    },
  },

  // Default strings
  STRINGS: {
    signed_with_bankid: `Signerat med BankID ${v.date}`,

    // Platform related settings (to be fixed)
    platform_email: "kundservice@jool.se",
    platform_tel: "031-797 19 36",

    'confirm': 'Bekräfta',
    abort: "Avbryt",

    accept_and_proceed: "Godkänn och gå vidare",
    accept_terms_confirm: "Jag är medveten om och bekräftar:",
    accepted: "Accepterad",
    accomplished: "Avklarad",
    account_balance: "Kontobalans",
    account_number: "Kontonummer",
    account: "Konto",
    accrued_interest: "Upplupen ränta",
    acquisition_cost: "Anskaffningsvärde",
    actions: "Verktyg", // used in CRM for som tools to edit
    active_investments: "Handla", // Aktiva investeringar
    add_row: "Lägg till rad",
    add: "Tillägg",
    advice: "Rådgivning",
    aftersale: "Efterköpsinformation",
    all_accounts: "Alla konton",
    all: "Alla",
    amortization: "Amortering",
    amount_exkl_court: `Belopp (${v.unit}, exklusive courtage)`,
    amount: "Antal",
    and: "och",
    annual_interest_rate: "Årlig räntesats",
    annually: "Årsvis",
    answer: "Svara",
    aptitude_test: "Passandeprövning",
    aptitude_assessment: "Passandebedömning",
    arranger: "Arrangör",
    at_maturity: "Vid förfallodag",
    attach_file_desc:
  <Fragment>
    eller <strong>släpp den här</strong>
  </Fragment>
    , // As in <button>Attach file</button> or drag and drop
    attach_file: "Bifoga fil",
    autogiro_transfer_info:
      "Vid överföring via autogiro kommer vi att hämta pengar direkt från ditt konto om 1–3 bankdagar. Det betyder att du behöver ha tillräckligt med likvida medel på det konto du har angett vid registrering för autogiro. Om du saknar teckning, kommer vi göra ett nytt försök vid ett senare tillfälle.",
    await_assignment: "Invänta tilldelning",
    await_delivery: "Invänta leverans",
    await_match: "Invänta matchning", // new meaning, before "Betala"
    await_payment: "Invänta betalning",
    ba_modal_text:
      "För att kunna ge dig och andra kunder så bra råd som möjligt önska vi att du meddelar din rådgivare med varför du nekade just detta rådet. Tack på för hand.",
    ba_modal_title: "Du valde att neka till ditt råd",
    back_to_start: "Tillbaka till startsidan",
    balance: "Saldo",
    begin_transfer: "Påbörja flytt",
    beneficial_owner: "Bolagsperson",
    beneficial_owners: "Bolagspersoner",
    block_sale: "BLOCK SALE",
    branch: "Bransch",
    brokerage: "Courtage",
    broker_advice_risk_info:
  <Fragment>
    <p>
      JOOL Markets använder en 7 gradig riskskala, där JOOLs investeringar i
      obligationer och direktlån anses vara högriskplaceringar och har
      risken 7 av 7
    </p>
    <p>
      Detta baseras bland annat på att man kan förlora mer än 25% av sitt
      investerade belopp under ett års tid. Investeringen innebär även
      exponering mot ett enskilt bolag och risken är inte spridd över ett
      flertal bolag som i exempelvis en fond. Utöver detta finns det även en
      likviditetsrisk då det kan vara svårt att sälja sitt innehav i förtid.
      Det kan även finnas likviditetsrisk som rör exempelvis fastigheter, då
      panter tas i anspråk. Det finns även en risk att emittenten behöver
      refinansiera sin verksamhet, och därmed finns risken att emittenten
      inte lyckas ta in nytt kapital vid obligationens slutdatum. Det finns
      även en ränterisk, då investeringen har en exponering för förändring
      av det allmänna ränteläget. Det finns även en risk att emittenten inte
      kan driva den operationella verksamheten, på grund av exempelvis att
      de inte erhåller tillstånd som krävs.
    </p>
    <p>
      Ytterligare information om riskfaktorer som är specifika för er
      investering finns angivet i investeringsunderlaget. Detta finner ni
      ovan under rubriken Dokument och vi omber er att även läsa igenom hela
      investeringsunderlaget.
    </p>
  </Fragment>
    ,
    buy: "Köp",
    ca: "ca", // Ex ca 6-8%
    call_dates: "Förtidsinlösen",
    "calyear-0": "Innevarande år",
    cancel: "Avsluta",
    cancelled: "Makulerad order",
    case: "Produkt",
    cash: "Kontant",
    "cash adjustment": "Justering av likvid",
    "cashflow out": "Kassaflöde out",
    "cashflow in": "Kassaflöde in",
    "fees correction": "Fees correction",
    change_lang: "Ändra språk",
    checkbox_disclaimer_life:
      "Att ingen investeringsrådgivning har genomförts. Att jag har erhållit samt läst PRIIPS-faktablad (KID) med nyckelinformation om min JOOL Life-försäkring. Att jag har tagit del av all investeringsdokumentation (inklusive KID för investeringen) och är införstådd med erbjudandets villkor samt de finansiella instrumentets egenskaper och risker. Att ett eventuellt delåterköp eller fullständigt återköp av min försäkring skulle kunna ske genom att investeringen överlåts till mig. Att jag accepterar att min investering kan resultera i förlust av delar eller hela investeringsbeloppet, och att jag har en ekonomisk situation som klarar av en sådan förlust. Att eventuell upplupen ränta kan tillkomma till det belopp jag behöver betala. Att det finns likvida medel i min kapitalförsäkring för den tilldelning jag erhåller med denna teckning.",
    checkbox_disclaimer_market:
      "Att ingen investeringsrådgivning har genomförts. Att jag har tagit del av all investeringsdokumentation och är införstådd med erbjudandets villkor samt de finansiella instrumentets egenskaper och risker. Att jag accepterar att min investering kan resultera i förlust av delar eller hela investeringsbeloppet, och att jag har en ekonomisk situation som klarar av en sådan förlust. Att eventuell upplupen ränta kan tillkomma till det belopp jag behöver betala. Att det finns likvida medel på mitt konto hos JOOL Markets AS för den tilldelning jag erhåller med denna teckning.",
    choose_payment_method: "Välj investeringssätt",
    classification: "Klassifikation",
    clearing_number: "Clearingnummer",
    click_here: "klicka här",
    close: "Stäng",
    collateral: "Säkerheter",
    company_customer: "Företagskund",
    company_registration: "Företagsregistrering",
    complete_order: "Genomför order",
    complete_registration_to_see_history:
      "Slutför hela registreringen för att se din portfölj, transaktioner och historik",
    complete_registration_to_see_payment_options:
      "Slutför hela registreringen för att se dina betalningsalternativ",
    confirm_bankid: "Bekräfta med BankID", // TODO: "Dev copy" Behåll om du gillar det
    contact_us_we_get_back:
      "Hör av dig till oss så återkommer vi så snart vi kan.",
    continue: "Gå vidare",
    "cost correction": "Korrigering",
    cost_fee: "Avgifter",
    cost: "Kostnad",
    costs: "Kostnader",
    country: "Land",
    coupon_percentage: "Kupongränta",
    coupon: "Kupong",
    create_account: "Skapa konto",
    create: "Skapa",
    current_events: "Mina händelser",
    current_investments: "Aktuella investeringar",
    customer_diligence_account_opening: "Kundkännedom & Kontoöppning",
    customer_registration: "Kundregistrering",
    delete_draft: "Radera utkast",
    denied: "Nekat",
    deposit_money: "Sätt in pengar",
    deposit: "Insättning",
    deposits: "Insättningar",
    details: "Detaljer",
    development: "Utveckling",
    direct_loans: "Direktlån",
    distribution: "Fördelning",
    document: "Dokument",
    documents: "Dokument",
    download_file: "Ladda ner fil",
    draft: "Utkast",
    drag_n_drop: "Klicka eller släpp dina filer här",
    drop_files_here: "Släpp filer här",
    dropdown_effect_title: "Hur påverkar avgifterna investeringens avkastning?",
    dropzone_text: "Klicka eller dra din fil hit", //en: Click ore drop your file here
    economic_situation: "Ekonomisk situation",
    edit_draft: "Redigera utkast",
    edit: "Redigera",
    effective_annual_rate: "Effektiv årsränta",
    endowment: "Resultat",
    enter_your_ssn: "Fyll i ditt personnummer",
    even_posts: "Poster om",
    "exchange-rate": "Senaste kurs",
    "exchange partially": "Konvertering",
    executed: "Genomförd order",
    facts_and_fees: "Fakta & avgifter",
    fetching_securities: "Hämtar investeringar...",
    final_balance: "Försäkringsvärde slutbalans",
    form_sent: "Formuläret är skickat",
    from_account: "Från konto", // used in withdrawal view'
    from: "Från",
    given: "Vald period",
    go_back: "Tillbaka",
    goals_economic_situation: "Lämplighetsprövning", // inside scentence for broker advice // TODO: move this when gets back from translators
    goals_excess: "överskottslikviditet", // inside scentence for broker advice // TODO: move this when gets back from translators
    goals_speculative: "medel som är öronmärkta för spekulativa investeringar", // inside scentence for broker advice // TODO: move this when gets back from translators
    good_to_know: "Bra att veta",
    help: "Hjälp", // For the help button
    hide_info: "Dölj information",
    high_lowercase: "hög",
    high: "Hög",
    holding: "Innehav",
    hours: "Timmar",
    how_do_you_wanna_use_the_service: "Hur vill du använda tjänsten?",
    how_it_works: "Så funkar det",
    icon: "ikon",
    id: " Id", // eg id on a security
    if_it_does_not: "Om det inte gör det,",
    image_or_video: "Bild eller Video",
    image: "Bild",
    increase_net_yield:
      "Öka din nettoavkastning med en kapitalförsäkring hos JOOL Life",
    increase_return:
      "Sprid dina risker och höj din avkastning tillsammans med andra investerare",
    increment_in_step: `% i steg om ${v.number}`, // v.number = a step value. ex 0.5 - used in secondary market trade order view
    interest_interval: "Ränteintervall",
    interest_payments: "Ränteutbetalningar",
    interest: "Ränta",
    invest_now: "Investera nu",
    invest: "Investera",
    investment_amount: "Investeringsbelopp",
    investment: "Investering",
    investments: "Investeringar",
    isin: "ISIN",
    issue_date: "Emissionsdag",
    issuer: "Emittent",
    key_points: "Nyckelpunkter",
    knowledge_test: "Kunskapstest",
    lang_en: "Engelska",
    lang_fi: "Finska",
    lang_no: "Norska",
    lang_se: "Svenska",
    last_coupon: "Senaste ränteutbetalningen",
    last_maturity_date: "Sista förfallodag",
    latest_messages: "Senaste meddelanden",
    latest_rate: "Senaste kurs",
    learning_material: "Inläsningsmaterial",
    leave_form_msg:
      "Är du säker på att du vill avsluta? Informationen du fyllt i kommer i så fall inte att sparas.",
    legal_advisor: "Legal rådgivare",
    liquid_funds: "Likvida medel",
    live: "Öppen",
    loading: "Laddar",
    locked_info:
  <Fragment>
    Du har angett att du endast accepterar och är villig att ta låg eller
    medelrisk på dina investeringar hos JOOL Markets. JOOL Markets erbjuder
    för tillfället dock inga placeringar med låg eller medelrisk och du kan
    därför inte gå vidare i processen. Om du har frågor är du välkommen att
    kontakta din rådgivare eller kundservice via epost{" "}
    <a className="link" href={`mailto:${v.email}`}>
      {v.email}
    </a>{" "}
    eller via telefon{" "}
    <a href="tel:0317971936" className="link">
      031 - 797 19 36
    </a>
  </Fragment>
    ,
    login_button: "Logga in med BankID",
    login_error_alert: `Något gick fel. Vänligen kontrollera ditt personnummer och försök igen. Om felet kvarstår, kontrollera att du har skapat ett konto.`,
    login_registration_in_progress: "Registreringen är inte färdig",
    login_window_opens_automatically:
      "Inloggningsfönstret kommer öppnas automatiskt.",
    logout_modal_button: "Fortsätt vara inloggad",
    logout_modal_desc: "Du kommer snart att loggas ut på grund av inaktivitet.",
    logout_modal_title: "Du kommer snart att loggas ut",
    token_has_expired: "Du har loggats ut",
    token_has_expired_desc: "Du har loggats ut på grund av inaktivitet.",
    logout: "Logga ut",
    low: "Låg",
    "management fee other ifa":
      "Rörlig avgift - Tidigare försäkringsdistributör",

    market_value: "Marknadsvärde",
    market: "Marknad",
    maturity_date: "Förfallodag",
    maturity_in: "Förfaller",
    max_volume: "Max volym",
    medium_high: "medelhög",
    medium: "Mellan",
    messages: "Meddelanden",
    min_investment: "Min. investering",
    min: "Min", // Like in Minimum investment
    minimize: "Minimera", // as in hide all posts
    minimum_investment: "Minsta investering",
    monthly: "Månadsvis",
    "months-3": "3 mån",
    my_accounts: "Mina konton",
    my_pages: "Mina sidor",
    "my-portfolio": "Min portfölj",
    name: "Namn",
    need_adequate_funds:
      "För att köpet ska kunna genomföras behöver du ha tillräckligt med kontanter på ditt konto senast",
    need_help: "Behöver du hjälp?",
    new_deposit: "Premieinsättning",
    next_coupon: "Nästa ränteutbetalning",
    next_question: "Nästa fråga",
    next_step: "Nästa steg",
    next: "Nästa",
    no_acccounts_available: "Inga konton tillgängliga",
    no_data_found_in_period: "Ingen data hittad inom den valda perioden",
    no_data_found: "Vi hittade ingen data",
    no_data_yet: "Det finns ingen data att visa än.",
    no_events_at_the_moment: "Just nu finns inga aktuella händelser.",
    no_holdings_at_this_point:
      "Just nu har du inga investeringar i din portfölj.",
    no_holdings: "Inget innehav",
    no_investments_on_primary_market:
      "Det finns inte tillgängliga investeringar. Kontakta din investeringsrådgivare för mer information.",
    no_subject: "Inget ämne",
    nominal_amount: "Nominellt Belopp",
    notify_at_opening: "Meddela vid öppning",
    nprof: "Jag önskar att bli klassificerad som icke-professionell kund",
    observe_terms: "OBS! Alla villkor är indikativa",
    observe_values: "OBS! Alla värden är indikativa",
    of: "av",
    ongoing_payments: "Pågående betalningar",
    other_costs: "Övriga kostnader",
    overview: "Översikt",
    page_not_found_check_address:
  <Fragment>
    Vi hittade tyvärr inte sidan <strong>{v.path}</strong>. Kolla att du
    skrivit in rätt adress.
  </Fragment>
    ,
    page_not_found: "Hittade tyvärr inte sidan",
    page: "Sida",
    part_plural: `Del ${v.number}`, // Ex Part 2
    part_singular: `Del ${v.number}`, // Ex Part 1
    pay_now: "Betala in",
    pay: "Betala",
    payment_options_info:
  <Fragment>
    Här kan du bestämma hur du vill att betalningar ska genomföras.
    <br /> Tänk på att vissa alternativ kan påverka hur snabbt betalningen
    kan genomföras.
  </Fragment>
    ,
    payment_options_ins:
  <Fragment>
    För att sätta in pengar i din försäkringsdepå måste du ladda hem
    blanketten tilläggspremie och skicka denna till{" "}
    <a href="mailto:backoffice@joollife.com" className="link">
      backoffice@joollife.com
    </a>
    . Du finner denna blankett på under din inloggning på{" "}
    <a href="https://www.clientmanager.se" className="link">
      www.clientmanager.se
    </a>{" "}
    under fliken Library, alternativt på{" "}
    <a className="link" href="https://www.quantumleban.com/forums">
      www.quantumleben.com/forums
    </a>
    . Vid eventuella frågor kan du kontakta{" "}
    <a href="mailto:backoffice@joollife.com" className="link">
      backoffice@joollife.com
    </a>{" "}
    alternativt ringa oss på telefonnummer{" "}
    <a href="tel:0317971936" className="link">
      031 – 797 19 36
    </a>
    .{" "}
  </Fragment>
    ,
    payment_options: "Betalningsalternativ",
    payment_reference: "Betalningsreferens",
    payment: "Betalning", // Used in PayCard (event cards - ongoing investments)
    percent: "Procent",
    percent_today: "% idag",
    period: "Period",
    pnote: "Direktlån",
    policy_information: "Försäkringsinformation",
    policy: "Försäkring",
    policy_application: "Försäkringsansökan",
    prepare_investment: "Förbered investering",
    previous: "Föregående",
    price: "Kurs",
    purchase_price: "Inköpskurs",
    primary_market: "Primärmarknad",
    private_customer: "Privatkund",
    proceeds: "Avkastning",
    product_page: "Prod. sida",
    prof: "Jag önskar att bli klassificerad som professionell kund",
    profile_settings: "Mina uppgifter",
    promissory_note: "Direktlån",
    proxy: "Fullmakt",
    purpose: "Syfte",
    quarterly: "Kvartalsvis",
    questions_plural: `${v.number} frågor`, // Ex: 6 frågor
    questions_singular: `${v.number} fråga`, // Ex: 1 fråga
    rate: "Kurs", // Val av kurs, ex 98%
    read_more: "Läs mer",
    rec_period: "Rek. period",
    received_assignment: "Du har fått tilldelning om",
    records_of_min_investment: `Poster om ${v.number}`, // number = blocksize with currency ex "10 0000 SEK"
    redo_test: "Gör om testet",
    reduction_of_return: "Reducering av avkastning",
    register_for_autogiro: "Registrera autogiro",
    register_new_company: "Registrera nytt företag",
    registration: "Registrering",
    reload_page: "Ladda om sidan",
    rem_annual_interest_rate: "Åters. ränta",
    rem_running_time: "Åters. löptid",
    remaining_return: "Återstående avkastning",
    remaining_running_duration: "Löptid återstående",
    remove_file: "Ta bort",
    remove_row: "Ta bort rad",
    remove: "Makulering",
    repayment: "Återbetalning",
    report_error: "Rapportera fel",
    report_ins:
  <Fragment>
    Vänligen observera att denna rapport endast innehåller uppgifter om
    depån i din kapitalförsäkring hos Quantum Leben AG. För fullständig
    information om försäkringens innehav ombeds du logga in på{" "}
    <a href="https://www.clientmanager.se" className="link">
      www.clientmanager.se
    </a>
    . Vid eventuella frågor kan du kontakta{" "}
    <a href="mailto:backoffice@joollife.com" className="link">
      backoffice@joollife.com
    </a>{" "}
    alternativt ringa oss på telefonnummer{" "}
    <a href="tel:0317971936" className="link">
      031 – 797 19 36
    </a>
    .
  </Fragment>
    ,
    report: "Rapport",
    result_since_start: "Utveckling sedan start",
    result_this_year: "Utveckling hittills i år",
    result: "Resultat",
    rows: "rader",
    save_and_continue: "Spara och fortsätt",
    save_draft: "Spara utkast",
    save_test: "Spara testet",
    save: "Spara",
    saved_documents: "Sparade dokument",
    saving: "Sparar",
    secondary_updated_info:
      "Vi vill göra dig uppmärksam på att informationen som presenteras i emissionens marknadsföringsmaterial utarbetades i samband med emissionens lansering på primärmarknaden. Informationen i vardera emissionens marknadsföringsmaterial kan ha ändrats och slutliga fullständiga villkor finns i produktens slutliga term sheet.",
    seconds: "Sekunder",
    sector: "Bransch",
    securities: "Värdepapper",
    security_code: "Kod",
    security: "Investering",
    see_full_report: "Se fullständig rapport",
    see_more_info: "Se mer information",
    see_investments: "Se alla investeringar",
    select: "Välj",
    select_error_increment: `Välj en procentsats i steg om ${v.number}`, // number = a step value. ex 0.5
    select_error: "Vänligen välj ett eller flera alternativ",
    sell_entire_holding: "Sälj hela innehavet",
    sell: "Sälj",
    semi_annually: "Halvårsvis",
    send: "Skicka",
    sending: "Skickar",
    settlement_date: "Handelsdatum", //NEW!
    "share-of-portfolio": "Andel av portfolio",
    share: "Andel",
    shares: "Andelar",
    show_all: "Visa alla", // As in show all posts
    show_less: "Visa mindre",
    show_more_items: "Visa fler", // As in show more posts
    show_more: "Visa mer",
    show_productpage: "Visa produktsida",
    signatory: "Firmatecknare",
    signatories: "Firmatecknare",
    skip_to_main_content: "Hoppa till huvudinnehållet", // For a11y button to jump to the main content
    sold_out: "Slutsålt",
    sold: "Såld", // When a sell trade order has status executed
    something_went_wrong: "Något gick fel.",
    ssn_placeholder: "ååååmmddxxxx",
    start_test: "Starta testet",
    startpage: "Startsidan",
    status: "Status",
    structured_product: "Strukturerad Produkt",
    subscription_completed_info:
      "Din investeringsorder är mottagen. Du kan följa din investering via Mina konton.",
    subscription_completed_info_direct:
      "The Fully Arcade AB kommer inom kort att skicka ut en elektronisk teckningsanmälan till dig via Scrive där du kan signera via BankID.",
    subscription_completed: "Investeringsorder genomförd",
    subscription_completed_direct: "Intresseanmälan inskickad",
    subscriptions: "Teckningsanmälan",
    "subsription rights issue (c)": "Teckningsrätt",
    "subsription rights issue": "Teckningsrätt",

    sum: "Summa",
    summary_in_percent: "Sammanfattning i procent",
    summary: " Summering",
    terms: "Villkor",
    test_aptitude: "Passandeprövning",
    test_knowledge: "Kunskapstest", // dublicate of knowledge_test
    test_objective: "Lämplighetsprövning",
    test_terms: "Villkor & signering",
    tests_heading: "Investerartester", // kyc
    to_account: "Till konto", // used in withdrawal view
    to: "Till",
    tools: "Verktyg",
    total_fees: "Totala avgifter",
    // 'total_including_courtage': 'Totalt belopp* (inklusive avgifter)',
    including_courtage: "(inklusive avgifter)",
    "total_post-cost_fee": "Total avkastning efter avgifter",
    "total_pre-cost_fee": "Total avkastning före avgifter",
    total_value: "Totalt värde",
    total_volume: "Total volym",
    total: "Totalt belopp",
    trade_amount: "Belopp",
    trade_amount_new: "Belopp",
    transaction_fee: "Transaktionskostnad",
    transaction_ins:
  <Fragment>
    Vänligen observera att denna sida endast innehåller uppgifter om depån i
    din kapitalförsäkring hos Quantum Leben AG. För fullständig information
    om transaktionerna i din försäkringen ombeds du logga in på{" "}
    <a className="link" href="https://www.clientmanager.se">
      www.clientmanager.se
    </a>
    . Vid eventuella frågor kan du kontakta{" "}
    <a className="link" href="mailto:backoffice@joollife.com">
      backoffice@joollife.com
    </a>{" "}
    alternativt ringa oss på telefonnummer{" "}
    <a className="link" href="tel:0317971936">
      031 – 797 19 36
    </a>
    .
  </Fragment>
    ,
    transaction: "Transaktionstyp",
    transactions_and_notes: "Historiska transaktioner och notor",
    transactions: "Transaktioner",
    trustee: "Agent",
    try_again: "Försök igen",
    type: "Typ",
    upcoming_investments: "Kommande investeringar",
    update_report: "Uppdatera rapport",
    update: "Uppdatera", // Ex Money origin modal trigger button in /deposit
    upload_confirmation:
  <Fragment>
    Vi har tagit emot ditt document. Du kan see dina upladdade document
    under {v.link}
  </Fragment>
    , // link = profilinställningar
    use_of_capital: "Kapitalanvändning",
    value: "Värde",
    video: "Video",
    volume: "Volym",
    waitlist: "Väntelista",
    withdraw_money: "Ta ut pengar",
    withdrawal: "Uttag",
    "yearly-rate": "Årsränta",
    "years-1": "1 år",
    yield: "Avkastning",
    yield_percent: "Avkastning %",
    yield_currency: `Avkastning ${v.currency}`,
    you_will_see_messages_here:
      "Här kommer du snart att kunna se dina meddelanden.",
    your_account_balance: "Din kontobalans efter kommande köp:",
    your_answers: "Dina svar",
    your_documents: "Dina dokument",
    your_portfolio: "Din portfölj",
    zone_currency: "SEK",

    // Holding types
    bond: "Företagsobligationer",
    promnote: "Direktlån",
    "pe fund": 'Private Equity / Venture Capital',
    stock: "Onoterade Aktier",
    listedstock: "Noterade aktier",
    fund: "Fonder",
    currency: "Valutor",
    structured: "Strukturerade produkter",

    //Markets
    se: "Sverige",
    no: "Norge",
    fi: "Finland",

    // Sidebar helper
    email: "Epost",
    tel: "Tel",

    // Date and time
    bullet: "Allt på slutdagen",
    date: "Datum",
    day_plural: "dagar",
    day_singular: "dag",
    day_string_plural: `${v.number} dagar`, // ${v.number} will be replace with a plural number, ex -10 or 1.5
    day_string_short_plural: `${v.number} dagar`, // ${v.number} will be replace with a plural number, ex -10 or 1.5
    day_string_short_singular: `${v.number} dag`, // ${v.number} will be replace with a signular number, ex -1 or 0.5
    day_string_singular: `${v.number} dag`, // ${v.number} will be replace with a signular number, ex -1 or 0.5
    days: "Dagar",
    in_days_string_plural: `Om ${v.number} dagar`, // ${v.number} will be replace with a plural number, ex -10 or 1.5
    in_days_string_singular: `Om ${v.number} dag`, // ${v.number} will be replace with a signular number, ex -1 or 0.5
    minutes: "Minuter",
    month_string_plural: `${v.number} månader`, // ${v.number} will be replace with a plural number, ex -10 or 1.5
    month_string_short_plural: `${v.number} mån`, // ${v.number} will be replace with a plural number, ex -10 or 1.5
    month_string_short_singular: `${v.number} mån`, // ${v.number} will be replace with a signular number, ex -1 or 0.5
    month_string_singular: `${v.number} månad`, // ${v.number} will be replace with a signular number, ex -1 or 0.5
    month: "mån",
    time_left_to_open: "Tid kvar till öppning",
    year_string_plural: `${v.number} år`, // ${v.number} will be replace with a plural number, ex -10 or 1.5
    year_string_singular: `${v.number} år`, // ${v.number} will be replace with a signular number, ex -1 or 0.5
    year: "år",

    // Money
    millions_string: `${v.number} M${v.currency}`, // ex: 123 MSEK, ${v.number} - value in millions, ${v.currency} - the current currency
    percent_per_year: `${v.number}% per år`, // number = procent. ex 10% per year

    // Login view
    become_customer: "Bli kund",
    choose_account_login: "Välj konto att logga in med",
    companies: "Företag",
    login_company_registration_in_progress:
      "Företagsregistreringen är inte färdig",
    login_failed_message: "Inloggning misslyckades",
    login: "Logga in",
    private: "Privat",
    terms_conditions: "Villkor & signering",
    welcome_text: "Välkommen till JOOL",
    welcome_info:
      "Ditt konto är nu redo att användas. Om du har några frågor kan du alltid klicka på frågetecknet nere till höger.",
    choose_login_option: "Välj inloggningssätt",
    bankid_mobile: "Mobilt Bankid",
    bankid_device: "BankID med dosa",
    login_to_slow:
      "Du var för långsamt med att logga in. Du behöver slutföra inlogget inom 2min från det att du började logga in.",
    bankid_title: "Öppna BankID på din enhet",
    bankid_title_new: "Öppna BankID på din mobil",
    bankid_open: "Öppna BankID på denna enhet",
    bankid_start: `Du kan nu öppna BankID och signera dig mot ${v.platform} genom att scanna QR-koden ovan.`,
    bankid_button: "Öppna BankID på den här enheten",
    bankid_abort: "Avbryt signering",
    bankid_error:
  <>
    Något gick fel under inloggningen. Vänligen försök igen. Om problemet
    kvarstår, vänligen kontakta oss på{" "}
    <a
      href="mailto:kundservice@hubins.com"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@hubins.com
    </a>{" "}
    eller{" "}
    <a target="_blank" href="tel:0317971939" rel="noreferrer">
      031-797 19 39
    </a>
  </>
    ,
    registered_user_title: "Välkommen",
    login_user_text: 'Hos oss kan du logga in tryggt och säkert med ditt svenska BankID. Tänk ändå på att alltid hantera dina uppgifter varsamt.',
    here_login: 'Här loggar du in',
    registered_user_text:
      "Du har redan ett konto hos Hubins. Klicka på knappen nedan för att komma till dina sidor:",

    // Friendly reminder
    fr_description:
      "Det finns några steg kvar att göra innan du kan använda tjänsten. Du kan genomföra stegen när du vill.",
    fr_title: "Du är igång!",
    yearly_reminder: "Årlig påminnelse",

    // Logout view
    logging_out: "Loggar ut",
    logout_description: "Omdirigerar dig till startsidan",
    logout_title: "Du är utloggad",

    // Deposit / Withdrawal view
    // New
    deposit_details: "Deposit details",
    "deposit - sale": "Deposit - Sale",
    deposit_details_text:
      "Specify account and what amount you want to deposit.",
    // 'money_origin_title': 'Where do your securities or money come from?',
    // 'money_origin_text': 'Are your answers given at the time of registration still correct?',
    // 'demand_assesment_text': `You completed your Demand assessment ${v.date}. If your demand has changed since this date, please update your current demand.`,

    // Old: check if need's to be removed
    autogiro_agree: "Jag godkänner villkoren för betalning via autogiro",
    autogiro_sub_description:
  <Fragment>
    Om du önskar ändra ditt föranmälda konto, ber vi dig kontakta din
    mäklare eller vår kundservice på{" "}
    <a className="link" href="tel:0317971936">
      031-797 19 36
    </a>
  </Fragment>
    ,
    autogiro_subtitle: "Ditt föranmälda konto",
    autogiro_terms: "Villkor för betalning via Autogiro",
    autogiro_title: "Du har inte föranmält något konto för autogiro",
    available_for_withdrawal_info:
      "I din kapitalförsäkring behöver du ha likvida medel tillgängliga för att täcka framtida kostnader, motsvarande ca 6 månader.",
    available_for_withdrawal: "Tillgängligt för uttag",
    bank_transfer_bankgiro: "Bankgiro",
    // 'bank_transfer_bankgiro': 'Bankgiro / Banköverföring', JOOL removed Banköverföring för svenska användare
    bank_transfer: "Banköverföring",
    bank: "Bank",
    bankgiro_number: "Bankgironummer",
    bankgiro_payment: "Bankgirobetalning",
    bankgiro: "Bankgiro",
    conducts_deposit: "Genomför insättning",
    deposit_money_ins:
  <Fragment>
    För att sätta in pengar i din försäkringsdepå måste du ladda hem
    blanketten tilläggspremie och skicka denna till{" "}
    <a className="link" href="mailto:backoffice@joollife.com">
      backoffice@joollife.com
    </a>
    . Du finner denna blankett på under din inloggning på{" "}
    <a className="link" href="https://www.clientmanager.se">
      www.clientmanager.se
    </a>{" "}
    under fliken Library. Vid eventuella frågor kan du kontakta{" "}
    <a className="link" href="mailto:backoffice@joollife.com">
      backoffice@joollife.com
    </a>{" "}
    alternativt ringa oss på telefonnummer{" "}
    <a className="link" href="tel:0317971936">
      031 – 797 19 36
    </a>
    .
  </Fragment>
    ,
    deposit_payment_option_desc:
      "Om du önskar att byta betalningsalternativ går det att göra under dina profilinställningar.",
    deposit_payment_settings_link: "Ändra betalningsalternativ",
    direct_debit: "Autogiro",
    documents_terms: "Användaravtal & Villkor",
    sign_bankid: "Signera med BankID",
    sign_open_new_window: "Signering öppnas i nytt fönster",

    withdraw_money_ins:
  <Fragment>
    För att ta ut pengar ur din försäkringsdepå måste du ladda hem
    blanketten uttag och skicka denna till{" "}
    <a className="link" href="mailto:backoffice@joollife.com">
      backoffice@joollife.com
    </a>
    . Du finner denna blankett under din inloggning på{" "}
    <a className="link" href="https://www.clientmanager.se">
      www.clientmanager.se
    </a>{" "}
    under fliken Library. Vid eventuella frågor kan du kontakta{" "}
    <a className="link" href="mailto:backoffice@joollife.com">
      backoffice@joollife.com
    </a>{" "}
    alternativt ringa oss på telefonnummer{" "}
    <a className="link" href="tel:0317971936">
      031 – 797 19 36
    </a>
    .
  </Fragment>
    ,
    withdrawal_reason: "Andledning till uttag",
    withdrawal_reason_investment: "Investering",
    withdrawal_reason_saving_in_institute: "Sparande i annan institution",
    withdrawal_reason_consumption: "Konsumtion",
    withdrawal_reason_other: "Övrigt",
    confirm_withdrawal: "Bekräfta uppgifter",

    choose: "Välj", // choose a reason for withdrawel
    conduct_withdrawal: "Genomför uttag",
    debpay: "Skuldbetalning",
    direct_debit_success_ingress:
      "Vi kommer inom 1–3 bankdagar att dra pengar från det konto du har angett vid registreringen för autogiro. Därför är det viktigt att det finns tillgängligt med likvida medel på ditt konto.",
    direct_debit_success_title: "Överföring via autogiro registrerad",
    faq_a1:
      "Beroende på vilket betalningsalternativ du väljer samt vilken bank du har, varierar tiden det tar för insättningen att synas på ditt konto. Från och med att du initierat en insättning via din bank, tar det 1–3 bankdagar för pengarna att vara synliga i ditt konto.",
    faq_q1: "När syns pengarna på mitt konto?",
    FAQ: "FAQ",
    market_buy_success_ingress:
  <Fragment>
    <p>
      Din order kommer vara aktiv i 1 månad. Vi meddelar dig om matchande
      säljare hittas.
    </p>
    <p>Följ orderns status på mina konton.</p>
  </Fragment>
    ,
    market_buy_success_title: "Köporder registrerad",
    market_sell_success_ingress:
  <Fragment>
    <p>
      Din order kommer vara aktiv i 1 månad. Vi meddelar dig om matchande
      köpare hittas.
    </p>
    <p>Följ orderns status på mina konton.</p>
  </Fragment>
    ,
    market_sell_success_title: "Säljorder registrerad",
    new_withdrawal: "Nytt uttag",
    wd_info_header: "Uttag sker till ditt föranmälda konto",
    wd_info_text:
  <Fragment>
    Om du önskar att ändra ditt föranmälda konto, vänligen kontakta
    kundtjänst på <a href="tel:031-797 19 36">031-797 19 36</a>
  </Fragment>
    ,
    withdrawal_accept_terms_text:
      "Jag bekräftar och godkänner att pengarna går till mitt föranmälda konto.",
    withdrawal_reason_text: "Fyll i anledning till uttag",
    withdrawal_success_ingress: `Ditt uttag har registerats på ditt konto hos ${v.app_name}.Du kommer se pengarna på ditt föranmälda konto inom 1–3 bankdagar. Tiden kan variera beroende på vilken bank du har.`,
    withdrawal_success_title: "Uttag genomfört",

    dropdowneffect_desc:
      "Vänligen notera att vi endast tar hänsyn till courtaget i denna illustration",

    // Transfer Instructions
    bank_details: "Bankuppgifter",
    "bank fee": "Bank Fee",
    list_of_banks_text:
      "Här finns länkar till de vanligaste bankerna i Sverige",
    payment_amount: "Inbetalningsbelopp",
    pi_from_bank: "Notera att betalningen görs till SIP NORDIC AB.", // payment instruction from what bank the money will be tranfered to
    ti_info: `När allt är klart kommer insättningen synas på ditt konto ${v.name} `, // name - the account name
    // 'ti_step1': 'Logga in på din bank',
    // 'ti_step2': 'Välj ny betalning och betalningssätt',
    // 'ti_step3': 'Fyll i bankuppgifterna och referensnumret',
    // 'ti_step4': 'Genomför betalningen',
    payment_instructions:
      "Gå till din internetbank och genomför insättning med uppgifterna nedan.",

    // Money origin (also used in income source in registration)
    previous_investments: "Tidigare investeringar",
    inheritance_gift: "Arv/Gåva",
    property_sale: "Fastighetsförsäljning",
    insurance_payout: "Försäkringsutbetalning",
    dividend: "Utdelning",
    salary_pension: "Lön/Pension",
    lottery_gaming: "Lotteri/Spel",
    corporate_sales: "Företagsförsäljning",
    share_dividend_from_own_company: "Aktieutdelning från eget bolag",
    profits_daily_operations: "Vinster från den dagliga verksamheten",
    "profit correction": "Korrigering av utbetalning",
    "deposit correction": "Deposit correction",
    dividend_associated_comp: "Aktieutdelning från intressebolag",
    money_origin_other: "Annat",

    income_source: "Varifrån kommer dina pengar eller värdepapper?",
    company_income_source:
      "Varifrån kommer företagets pengar eller värdepapper?",
    income_source_text: "Stämmer fortfarande dina svar från registreringen?",

    // Buy /sell market bonds
    available_for_purchase: "Disponibelt",
    available_for_purchase_amount: "Disponibelt belopp",
    blocksize: "Handlas i poster om",
    bonds_amount: "Antal handelsposter",
    stocks_amount: "Antal aktier",
    company_bonds_amount: "Antal obligationer",
    buy_bonds: "Köp obligationer",
    buy_terms:
      'Att ingen investeringsrådgivning har genomförts. Att jag har tagit del av allt marknadsföringsmaterial, all investeringsdokumentation och är införstådd med erbjudandets villkor samt de finansiella instrumentets egenskaper och risker. Att produkten jag har placerat i betraktas ha högsta risken 7 på en 7-gradig skala och är en produkt med hög risk. Att jag accepterar att min investering kan resultera i förlust av delar eller hela investeringsbeloppet, och att jag har en ekonomisk situation som klarar av en sådan förlust. Att det finns likvida medel på mitt konto hos JOOL Markets AS för den tilldelning jag erhåller med denna teckning. Att jag är införstådd med att JOOL Markets AS kommer tillhandahålla andrahandsmarknaden för obligationer på "Best Effort" basis.',
    choose_account: "Välj konto",
    choose_amount: "Välj summa",
    choose_investment: "Välj investering",
    info_about_fund: "Information om obligationen",
    info_about_stock: `Information om den onoterade aktien`,

    jool_life_terms:
      "Att ingen investeringsrådgivning har genomförts. Att jag har erhållit samt läst PRIIPS-faktablad (KID) med nyckelinformation om min JOOL Life-försäkring. Att jag har tagit del av all investeringsdokumentation (inklusive KID för investeringen) och är införstådd med erbjudandets villkor samt de finansiella instrumentets egenskaper och risker. Att ett eventuellt delåterköp eller fullständigt återköp av min försäkring skulle kunna ske genom att investeringen överlåts till mig. Att jag accepterar att min investering kan resultera i förlust av delar eller hela investeringsbeloppet, och att jag har en ekonomisk situation som klarar av en sådan förlust. Att eventuell upplupen ränta kan tillkomma till det belopp jag behöver betala. Att det finns likvida medel i min kapitalförsäkring för den tilldelning jag erhåller med denna teckning.",
    marketorder_terms:
      "Att ingen investeringsrådgivning har genomförts. Att jag har tagit del av allt marknadsföringsmaterial, all investeringsdokumentation och är införstådd med erbjudandets villkor samt de finansiella instrumentets egenskaper och risker. Att produkten jag har placerat i betraktas ha högsta risken 7 på en 7-gradig skala och är en produkt med hög risk. Att jag som kund accepterar att min investering kan resultera i förlust av delar eller hela investeringsbeloppet, och att jag som kund har en ekonomisk situation som klarar av en sådan förlust. Att det finns eller kommer sättas in likvida medel på mitt konto hos JOOL Markets AS för den tilldelning jag erhåller med denna teckning.",
    order_validity_terms: "Notera att uppluppen ränta kan tillkomma.",
    order_validity: "Orderns giltighet",
    ordering: "Orderläggning",
    remaining_rate: "Ränta återstående ",
    sell_bonds: "Sälj innehav",
    "value adjustment": "Value adjustment",
    "Transaction fee": "Transaction fee",
    "transaction charge ql1": "Transaktionskostnad, Quantum",
    "transaction charge ql2": "Transaktionskostnad, Utkontraktering",
    sell_terms:
      'Att ingen rådgivning har genomförts för denna säljorder. Att jag vill sälja mina andelar i innehavet i ovan angivna värdepapper och att jag förstår egenskaperna av denna säljorder samt de associerade kostnaderna med denna försäljning. Att jag är införstådd att JOOL Markets AS kommer tilhanda hålla andrahandsmarknad för obligationer på "Best Effort" basis.',
    transaction_fee_terms_tooltip:
  <Fragment>
    <p>
      När man köper värdepapper på andrahandsmarknaden så kan det tillkomma
      en upplupen ränta för köparen ifall värdepapperet är en obligation
      eller liknande räntebärande värdepapper. Beloppet motsvarar den ränta
      som ännu inte betalats ut sedan den senaste ränteutbetalningen och
      räknas fram till datumet då affären genomförs. Räntan utgår från det
      nominella beloppet, alltså till pris 100%.
    </p>
    <p>
      <strong>
        I praktiken betyder det att köparen betalar för den upplupna räntan
        men får hela ränteutbetalningen vid nästa tillfälle, inklusive den
        upplupna räntan.
      </strong>
    </p>
    <p>
      Övriga avgifter hos produktbolaget såsom säljavgift etc. kan
      tillkomma. Vänligen se villkoren för den specifika investeringen för
      mer information.
    </p>
  </Fragment>
    ,
    transaction_fee_terms:
      "Notera att uppluppen ränta samt eventuella övriga avgifter hos produktbolaget kan tillkomma.",

    //Alerts
    autogiro_clarification:
      "Vid autogirobetalning kommer pengar per automatik dras från ditt förvalda konto.",
    autogiro_error_alert: `Något har hänt med din autogirokoppling till oss för kontot "${v.name}".Vänligen kontakta oss på 031 - 797 19 36 eller ${v.email} `,
    autogiro_waiting_alert: `Vi bearbetar just nu din autogiroansökan för "${v.name}"`,
    cancel_autogiro_modal:
      "För att avsluta ditt autogiro ber vi dig vänligen kontakta din bank eller logga in på din internetbank",
    cancel_autogiro: "Avsluta autogiro permanent",
    company_registration_in_progress:
      "Din företagsregistrering bearbetas just nu av JOOL. Vi meddelar dig när det är färdigt.",
    not_all_signatories_signed: "Alla firmatecknare/huvudmän har ännu inte skrivit på fullmakten. Under profilinställningar kan du se vilka som har slutfört registreringen.",
    yearly_reminder_alert: "Lorem ipsum Du behöver fylla i de årliga testerna",

    //JOOL contact info
    jool_email: "kundservice@jool.se", // depricated. use platform_email instead
    jool_support_email: "kundservice@jool.se", // depricated. use platform_email instead
    jool_tel: "031-797 19 36", // depricated. use platform_tel instead
    "asset management fee": "Rörlig avgift",
    // Broker Advice
    // 'accept_terms_and_proposal': 'Acceptera villkoren samt förslaget',
    // 'broker_advice': // TODO: translations: removed "och" and replaced with. De in är {v.goalsText} ~och~. De utgör cirka
    //   <Fragment>
    //     <p>Baserat på den information som du har lämnat under registreringsprocessen råder JOOL dig att investera {v.amount} i {v.name}</p>
    //     <p>Du har angett att du önskar {v.expected_return_min}% till {v.expected_return_max}% i årlig avkastning på dina investeringar hos JOOL. Vidare har du angett att din investeringshorisont för enstaka investeringar hos JOOL Markets är mellan {v.term_min} och {v.term_max} månader, samt att du önskar ha en sammantagen investeringshorisont mellan {v.investment_horizon_min} till {v.investment_horizon_max} år på hela din portfölj hos JOOL Markets.</p>
    //     <p>{v.name} har {v.s_coupon}% i årlig ränta och en löptid om {v.period_in_months} månader, vilket är inom ramen för dina investeringspreferenser och är därmed lämpligt för dig.</p>
    //     <p>Du önskar hög risk på dina enskilda investeringar, för att få möjlighet till en hög avkastning, och är beredd samt accepterar att du kan förlora hela ditt investerade belopp. Du är medveten och accepterar att {v.name} anses ge mycket god avkastning och klassificeras som en högriskinvestering. Baserat på ovan är investeringens risknivå lämplig för dig.</p>
    //     <p>De medel som du investerar är {v.goalsText}. De utgör cirka {v.investable_percentage} av ditt placeringsbara kapital, vilket anses vara lämpligt då detta möjliggör riskspridning och att du kan bära en eventuell förlust. Din ekonomiska situation anses vara solid och en eventuell förlust av hela produktens värde bedöms inte påverka din finansiella situation markant. </p>
    //     <p>Baserat på informationen som du har lämnat, i kombination med avklarat kunskapstest, klassificerar JOOL din kunskap avseende de investeringar som huvudsakligen erbjuds av JOOL Markets, dvs högriskinvesteringar inom kategorierna noterade och onoterade företagsobligationer samt direktlån som {v.suitability_investment_experience}.</p>
    //     <p>Sammantaget bedömer JOOL att du har tillräckligt hög kunskap och erfarenhet för att förstå de risker och egenskaper som är kopplade till de investeringar som JOOL erbjuder.</p>
    //     <p>Kostnaden för denna transaktion är ett courtage om {v.courtage_percent} , motsvarande {v.courtage_amount}. Detta innebär att du under hela investeringsperioden väntas få ut {v.profit_percentage} i ränta efter kostnader. Minskningen av den totala avkastningen över hela investeringsperioden motsvarar {v.reduced_profit}</p>
    //     <p>Vänligen notera att, beroende på var du väljer att förvara ditt innehav kan skatter samt kostnader kopplade till transaktionen tillkomma.</p>
    //     <p>{v.description}</p>
    //     <p>Sammanfattningsvis är en investering om {v.amount} i {v.name} lämplig för dig med hänsyn till din finansiella situation samt kunskap- och erfarenhetsnivå. Det är även lämpligt då investeringens egenskaper faller inom ramen för dina önskemål gällande avkastning, löptid och riskvilja.</p>
    //   </Fragment>,

    // 'broker_advice_company':
    //   <Fragment>
    //     <p>Baserat på den information som du har lämnat under registreringsprocessen råder JOOL bolaget att investera {v.amount} i {v.name}</p>
    //     <p>Du har angett att bolaget önskar {v.expected_return_min}% till {v.expected_return_max}% i årlig avkastning på bolagets investeringar hos JOOL. Vidare har du angett att bolagets investeringshorisont för enstaka investeringar hos JOOL Markets är mellan {v.term_min} och {v.term_max} månader,
    //     samt att bolaget önskar ha en sammantagen investeringshorisont mellan {v.investment_horizon_min} till {v.investment_horizon_max} år på hela bolagets portfölj hos JOOL Markets.</p>
    //     <p>{v.name} har {v.s_coupon}% i årlig ränta och en löptid om {v.period_in_months} månader, vilket är inom ramen för bolagets investeringspreferenser och är därmed lämpligt för bolaget.</p>
    //     <p>Bolaget önskar hög risk på bolagets enskilda investeringar, för att få möjlighet till en hög avkastning, och är beredd samt accepterar att bolaget kan förlora hela bolagets investerade belopp. Du är medveten och accepterar att {v.name} anses ge mycket god avkastning och klassificeras som en högriskinvestering. Baserat på ovan är investeringens risknivå lämplig för bolaget.</p>
    //     <p>De medel som bolaget investerar är {v.goalsText} och utgör cirka {v.investable_percentage} av det totala investeringsbeloppet som avses placeras via JOOL under innevarande 12-månaders perioden och cirka {v.total_company_assets_percentage} av bolagets totala tillgångar. Detta  anses vara lämpligt då detta möjliggör riskspridning och att bolaget kan bära en eventuell förlust. Bolagets ekonomiska situation anses vara solid och en eventuell förlust av hela produktens värde bedöms inte påverka bolagets finansiella situation markant. </p>
    //     <p>Baserat på informationen som du har lämnat, i kombination med avklarat kunskapstest, klassificerar JOOL din kunskap avseende de investeringar som huvudsakligen erbjuds av JOOL Markets, dvs högriskinvesteringar inom kategorierna noterade och onoterade företagsobligationer samt direktlån som {v.suitability_investment_experience}.</p>
    //     <p>Sammantaget bedömer JOOL att du har tillräckligt hög kunskap och erfarenhet för att förstå de risker och egenskaper som är kopplade till de investeringar som JOOL erbjuder.</p>
    //     <p>Kostnaden för denna transaktion är ett courtage om {v.courtage_percent} , motsvarande {v.courtage_amount}. Detta innebär att bolaget under hela investeringsperioden väntas få ut {v.profit_percentage} i ränta efter kostnader. Minskningen av den totala avkastningen över hela investeringsperioden motsvarar {v.reduced_profit}</p>
    //     <p>Vänligen notera att, beroende på var bolaget väljer att förvara sitt innehav kan skatter samt kostnader kopplade till transaktionen tillkomma.</p>
    //     <p>{v.description}</p>
    //     <p>Sammanfattningsvis är en investering om {v.amount} i {v.name} lämplig för bolaget med hänsyn till din och bolagets finansiella situation samt kunskap- och erfarenhetsnivå. Det är även lämpligt då investeringens egenskaper faller inom ramen för bolagets önskemål gällande avkastning, löptid och riskvilja.</p>
    //   </Fragment>,
    // 'broker_advice_terms': 'Att jag har tagit del av allt marknadsföringamaterial, all investeringsdokumentation och är införstådd med erbjudandets villkor samt de finansiella instrumentets egenskaper och risker. Att produkten jag har placerat i betraktas ha högsta risken 7 på en 7-gradig skala och är en produkt med hög risk. Att jag accepterar att min investering kan resultera i förlust av delar eller hela investeringsbeloppet, och att jag har en ekonomisk situation som klarar av en sådan förlust. Att det finns likvida medel på mitt konto hos JOOL Markets AS för den tilldelning jag erhåller med denna teckning."',
    // 'deny_proposal': 'Avvisa förslaget',
    // 'message_advisor': 'Skicka meddelande',
    // 'write_message': 'Skriv meddelande',
    // 'investment_advice': 'Investeringsråd',
    // 'investment_amount_total': 'Totalt investeringsbelopp',
    // 'investment_information': 'Investeringsuppgifter',
    // 'min_amount_x': `Minimum ${v.amount} `, // Minimum 10 000 SEK
    // 'risk': 'Risk',
    // 'tests_need_update_info':
    //   <Fragment>
    //     <p className="clarification">Dina svar är updaterade och behöver inte göras om förrän <strong className="c-black">{v.date}</strong></p>
    //     <p className="clarification">Om du önskar att uppdatera dina svar ber vi dig kontakta <a className="link" href={`mailto: ${v.email} `}>{v.email}</a> eller<br /> ring oss på <a className="link" href="tel:{0317971936}">031-797 19 36</a></p>
    //   </Fragment>,
    // 'running_time': 'Löptid',
    // 'your_investment_advice': 'Ditt investeringsråd',

    // Error messages
    correct_data_not_loaded:
      "Vi kan för tillfället inte hämta korrekt data. Testa att logga ut och logga in igen.",
    bad_network:
      "Det verkar vara något fel på din internetanslutning. Testa att ladda om sidan.",
    checkbox_error: "Obligatoriskt för att kunna gå vidare",
    dropdown_error: "Välj ett av alternativen",
    empty_rows: "Ingen data tillgänglig", // Ex when rows missing in expandable table
    error_amount: "Fyll i ett belopp",
    error_email: "Fyll i en korrekt epost-adress",
    error_empty: "Fyll i det tomma fältet",
    error_form: "Vänligen titta igenom formuläret efter felmeddelanden",
    error_max_value: `Värdet måste vara max ${v.number} `, // Number is the provided max value
    error_min_value: `Värdet måste vara minst ${v.number} `, // Number is the provided min value
    error_not_enough_data: "Otillräcklig data", // Example diagram that has not data
    error_options: "Välj ett av alternativen",
    error_number: "Endast siffror är tillåtna",
    error_pattern: `Fyll i ett giltigt värde.Giltiga tecken är ${v.pattern} `, // pattern is the provided pattern
    error_step: `Fyll i ett giltigt tal.Närmsta giltiga tal är ${v.value} `, // pattern is the provided pattern, eg 10 or 15, instead of 10.2 or 15.8
    error_underaged: "Du måste tyvärr vara äldre än 18",
    input_error: "Fyll i det tomma fältet",
    no_documents: "Inga dokument hittades", // is shown in the <Documents> component ex on /settings#documents
    ssn_validation_error: "Felaktigt personnummer (ÅÅÅÅMMDDXXXX)",
    org_validation_error: "Felaktigt organisationsnummer (XXXXXX-XXXX)",
    standard_error_message:
  <>
    Något har tyvärr gått fel men försök gärna igen om en liten stund. Om
    felet kvarstår får ni gärna maila{" "}
    <a href={`mailto:${v.email}`}>{v.email}</a> eller ringa oss på{" "}
    <a href={`tel:${v.tel}`}>{v.tel}</a>.
  </>
    ,

    // Statuses
    status_reg_comp: "Registrerar företag",
    status_fetching_holdings: "Hämtar innehav",

    // Dashboard
    type_buy: "Köp", // type of trade order
    type_wdsec: "Uttag",
    wdsec_title: "Uttagsbegäran mottagen",
    wdsec_text: "Er uttagsbegäran är mottagen av försäkringsbolaget",
    wdsec_title_2: 'Uttag genomfört',
    wdsec_text_2: 'Uttag genomfört.',
    type_surr: 'Avslutsbegäran',
    surr_text: 'Er avslutsbegäran är mottagen',
    surr_text_2: 'Avslut genomförd',
    surr_title: 'Avslut pågår',
    surr_title_2: 'Avslut genomförd',

    type_deposit: "Insättning", // type of trade order
    type_sell: "Sälj", // type of trade order
    type_withdrawal: "Uttag", // type of trade order
    type_add: "Inlägg",
    type_s: 'Sälj',
    type_b: 'Köp',
    type_exch: 'Konvertering',
    type_pre: 'Insättning',
    type_presec: 'Inflytt',
    type_wd: 'Uttag',
    "type_premium security": "Inflytt av värdepapper",

    await_delivery_deposit: "Inväntar insättning",
    buy_course: "Köpkurs",
    depositcard_directdebit_info:
      "Beloppet kommer dras från ditt konto inom några dagar. Se till att det finns täckning på ditt konto.",
    directdebit_payment: "Autogirobetalning",
    executed_deposit: "Insättning genomförd",
    paycard_directdebit_info:
      "Du har fått tilldelning på en av våra investeringar. Beloppet kommer dras från ditt konto inom några dagar. Se till att det finns täckning på ditt konto.",
    paycard_manual_info: `Du har fått tilldelning på en av våra investeringar.Vänligen genomför en insättning till ditt ${v.name}.`, // name - the name of the users account ex JOOL Markets Depåkonto
    payment_info: "Betalningsinfo",
    sell_course: "Säljkurs",
    total_amount_brokerage: "Totalt belopp (inklusive avgifter)",
    total_amount: "Totalt belopp",
    view_advice: "Se förslag",
    view_productpage: "Se produktsida",

    // Event Cards
    premium: "Premieinsättning - Kontanter",
    buy_open_title: "Order mottagen",
    buy_open_text: "Er order är mottagen av försäkringsbolaget.",
    buy_accepted_title: "Order mottagen",
    buy_accepted_text:
      "Er order är mottagen av försäkringsbolaget.",
    buy_executable_title: "Order skickad",
    buy_executable_text: "Er order är skickad.",
    buy_executed_title: "Genomförd",
    buy_executed_text: "Er order är genomförd",
    buy_executed_withoutdate_title: "Köp genomfört",
    buy_executed_withoutdate_text:
      "Ditt köp är genomfört och har bokats in i din försäkring",
    sell_accepted_title: "Order mottagen",
    sell_accepted_text:
      "Er order är mottagen av försäkringsbolaget.",
    buy_sent: 'Er order är skickad.',
    buy_sent_title: 'Order skickad',
    sell_executable_title: "Order skickad",
    sell_executable_text: "Er order är skickad.",
    sell_executed_title: "Order genomförd",
    sell_executed_text:
      "Er order är genomförd.",
    sell_executed_withoutdate_title: "Pengar mottagna",
    sell_executed_withoutdate_text:
      "Er order är genomförd.",
    add_open_title: "Inflytt registrerad",
    add_open_text: "Din begäran om infyltt är registrerad",
    add_accepted_title: "Inflytt registrerad",
    add_accepted_text: "Din begäran om infyltt är registrerad",
    add_executed_title: "Inflytt inbokad",
    add_executed_text: "Din inflytt är registrerad",
    add_executed_withoutdate_title: "Din inflytt är registrerad",
    add_executed_withoutdate_text: "Din inflytt är registrerad",
    premium_open_title: "Premieinbetalning",
    premium_open_text:
      "Du har uppgett att du kommer att genomföra en inbetalning till din försäkringspolicy",
    premium_accepted_title: "Premieinbetalning",
    premium_accepted_text:
      "Du har uppgett att du kommer att genomföra en inbetalning till din försäkringspolicy",
    premium_executed_title: "Betalning genomförd",
    premium_executed_text:
      "Din betalning är utfärdad och inbokad på din försäkring",
    premium_executed_withoutdate_title: "Betalning genomförd",
    premium_executed_withoutdate_text:
      "Din betalning är utfärdad och inbokad på din försäkring",
    premium__security_pending_title: "Inflytt pågår",
    premium__security_executed_withoutdate: "Inflytt genomförd",
    presec_sent_to_counterpart: 'Er inflyttsbegäran är skickad till motpart',
    premium__security_cancelled_title: "Inflytt avbruten",
    premium__cancelled_title: "Insättning avbruten",
    premium_security_accepted_withoutdate_text: "-",
    premium_security_executable_withoutdate_text:
      "Din inflytt behandlas just nu.",
    premium_security_executed_withoutdate_text:
      "Din inflytt är genomförd och inbokad i din försäkring.",
    premium_security_open_withoutdate_text: "Din inflytt behandlas just nu.",
    premium_security_executable_text: "Din inflytt behandlas just nu.",
    // Interest indicator
    ii_up: "Positiv", // Utveckling: Positiv
    ii_down: "Negativ", // Utveckling: Negativ
    ii_middle: "Ingen utveckling", // Utveckling: Ingen utveckling

    // Yearly Checkup
    yc_title: "Vi behöver uppdatera dina svar",
    yc_desc_warning:
  <>
    <p>
      <strong>
        Lorem impsum Enligt lagen xxxx så måste vi varje år be dig svara på
        lorem ipsum för att lorem ipsum.
      </strong>
    </p>
    <p>
      <strong>Vänligen ta dig tid att fylla i alla svar nedan.</strong>
    </p>
  </>
    ,
    yc_desc_locked:
  <>
    <p>
      <strong>
        Lorem ipsum Du måste göra detta innan du kan fortsätta använda
        tjänsten. Enligt lagen xxxx så måste vi varje år be dig svara på
        lorem ipsum för att lorem ipsum.
      </strong>
    </p>
  </>
    ,

    yc_kt_action: "Gör kunskapstestet",
    yc_kt_desc:
      "Lorem ipsum. Du behöver genomföra kunskapstestet på nytt. Om du inte klarar testet på första försöket får du självklart en chans till!",
    yc_kt_error:
      "Du behöver gå igenom och klara hela kunskapstestet för att kunna gå vidare.",
    "edit-org-form": "Redigera hela formuläret",
    yc_locked_risk_text:
  <>
    Om du önskar att ändra ditt svar. Vänligen kontakta {v.platform} på{" "}
    {v.email}
  </>
    ,
    yc_success_title: "Tack för dina svar!",
    yc_success_desc:
  <p>
    Vi har uppdaterat din profil med dina svar. Du kan nu fortsätta att
    använda platformen precis som innan. Nästa datum då svaren kommer behöva
    uppdateras igen är {v.date}.
  </p>
    ,
    do_later: "Stäng och gör senare",
    market_value_start: "Försäkringsvärde startbalans",
    dev_during_period: "Utveckling under perioden",
    access_law: "Tillgångsslag",
    whole_period: "Hela perioden",
    endowment_title: "Utveckling per år (SEK)",

    total_insurance_fees: "Totala försäkringsavgifter",
    total_insurance_fees_ql: "Total ersättning till Quantum Leben AG",
    total_insurance_fees_hubins:
      "Total ersättning till Hubins för utkontrakterade tjänster åt Quantum",
    total_insurance_fees_hubins_1:
      "Total ersättning till Hubins för försäkringsdistribution",
    total_insurance_fees_other:
      "Total ersättning till tidigare försäkringsdistributör, ej Hubins",
    total_insurance_from_third_party:
      "Total ersättning som Hubins har mottagit från annan tredjepart än Quantum Leben AG (Ex. från fondbolag eller annat produktbolag)",
    total_insurance_to_third_party:
      "Total ersättning som Hubins har tillhandahållit till tredjepart",
    one_time_fee_total: "Engångsavgifter: Transaktionsavgift",
    one_time_fee_ql: "Varav ersättning till Quantum Leben AG",
    one_time_fee_hubins:
      "Varav ersättning till Hubins för utkontrakterade tjänster åt Quantum",
    running_fixed_cost_total: "Löpande avgifter: Fast avgift",
    running_fixed_cost_ql: "Varav ersättning till Quantum Leben AG",
    running_fixed_cost_hubins:
      "Varav ersättning till Hubins för utkontrakterade tjänster åt Quantum",
    running_variable_cost_total: "Löpande avgifter: Rörlig avgift",
    running_variable_cost_ql: "Varav ersättning till Quantum Leben AG",
    running_variable_cost_hubins:
      "Varav ersättning till Hubins för utkontrakterade tjänster åt Quantum",
    running_variable_cost_hubins1:
      "Varav ersättning till Hubins för försäkringsdistribution",
    running_cost_riskpre_total:
      "Löpande avgifter: Riskpremie (från 65 års ålder)",
    running_cost_riskpre_ql: "Varav ersättning till Quantum Leben AG",

    total_yield_without_fees:
      "Total avkastning utan försäkringsavgifter eller försäkringskostnader",
    total_fees_and_costs: "Totala försäkringsavgifter och försäkringskostnader",
    total_yield_after_fees_and_costs:
      "Total avkastning efter totala försäkringsavgifter och försäkringskostnader",
    insurance_fees: "Försäkringsavgifter och försäkringskostnader",
    yearly_report: "Årsrapport",
    fetching_yearly_report: "Hämtar årsrapport",
    yearly_report_header_title: "Logga in för att se din årsrapport",

    insurance_value_start: "Försäkringsvärde vid beskattningsårets ingång",
    premiums_start: "Premier januari-juni",
    premiums_half_end: "50% av premier juli-december",
    capital_base: "Kapitalunderlag",
    interest_rate: "Räntesats",
    tax_base: "Skatteunderlaget (Fylls i under punkt 9.1 i deklarationen)",
    tax_rate: "Skattesats",
    actual_tax_rate_before: "Faktisk beskattning innan nedsättning",
    total_paid_tax_during_year:
      "Total betald stämpelskatt under beskattningsåret samt överskjutande belopp från föregående år",
    total_paid_tax_down:
      'Total betald stämpelskatt för nedsättning (Anges under "Övriga upplysningar" i deklarationen)',
    total_tax_for_coming_year: "Överskjutande belopp till senare år",
    premiums_start_tooltip:
      "Premier som betalas under januari till juni räknas med i sin helhet.",
    tax_table_title: `Skatt och Deklaration - Utländsk kapitalförsäkring`,
    tax_table_text:
  <div>
    <p className="clarification">
      Hubins vill även göra dig uppmarksam på följande:
      <br />
      Vänligen notera att dessa beräkningar är indikativa och att Hubins
      inte ger någon form av skatterådgivning. Denna kalkyl tar endast
      hänsyn till den aktuella kapitalförsäkring som du har hos Quantum
      Leben AG. Vare sig Quantum Leben AG eller Hubins AB kan garantera
      riktigheten i beskattningen. Nedan beräkning tar heller inte hänsyn
      till hela din skattesituation.
    </p>
  </div>
    ,
    tax_table_text_1:
  <>
    <p className="clarification">
      En försäkringstagare som har en utländsk kapitalförsäkring får själv
      redovisa skatteunderlaget i sin inkomstdeklaration. Skatteunderlaget
      för en kapitalförsäkring beräknas enligt skatteverket i två steg.
      Först beräknas ett kapitalunderlag och därefter ett skatteunderlag.
      Beskattningsåret för avkastningsskatt är alltid kalenderår och
      kapitalunderlaget motsvarar försäkringens värde vid beskattningsårets
      ingång ökat med årets premiebetalningar. Kapitalunderlaget ska ökas
      med alla överföringar från försäkringstagare till försäkringen, dvs.
      både inbetalningar i form av likvida medel och tillgångar. Premier som
      betalas under januari till juni räknas med i sin helhet och premier
      som betalas under juli till december räknas bara med till hälften.
      Skatteunderlaget beräknas genom att kapitalunderlaget multipliceras
      med statslåneräntan den sista november, året innan beskattningsåret,
      plus 1 procentenhet. Skatteunderlaget ska dock beräknas till lägst
      1,25 procent av kapitalunderlaget (det finns således ett ”golv” för
      statslånelånräntan avseede den här typen av beräkning). Det innebär
      att om statslåneräntan vid utgången av november är lägre än 0,25
      procent ska kapitalunderlaget multipliceras med 1,25 procent.
      Skatteunderlaget avrundas nedåt till ett helt hundratal kronor. Läs
      mer om detta på Skatteverket hemsida:{" "}
      <a
        href="https://skatteverket.se/privat/skatter/forsakringar/avkastningsskattpautlandskalivforsakringar/kapitalforsakringfran2012.4.3684199413c956649b57c4b.html"
        target="_blank"
        rel="noreferrer"
      >
            https://skatteverket.se/privat/skatter/forsakringar/avkastningsskattpautlandskalivforsakringar/kapitalforsakringfran2012.4.3684199413c956649b57c4b.html
      </a>
    </p>
    <p className="clarification">
      Stämpelskatten Stamp duty i Liechtenstein anses som utländsk
      punktskatt och man har rätt att sätta ned den svenska
      avkastningskatten med utländsk skatt som försäkringstagaren själv
      eller försäkringsföretaget har betalat för försäkringen. Den
      debiterade stämpelskatten i försäkringen framgår oftast i form av en
      initial stämpelskatt på 0,15 % av den inbetalade premien i likvida
      medel, eller 0,3 % vid inflytt av värdepapper, samt en stämpelskatt
      för återköp på 0,15 % av det återköpta likvidbeloppet och en
      stämpelskatt för återköp av värdepapper på 0,30 %. För att göra en
      nedsättning av avkastningsskatt anges det beloppet för nedsättning
      under övriga upplysningar i din inkomstdeklaration. Läs mer om detta
      på Skatteverkets hemsida:{" "}
      <a
        href="https://skatteverket.se/privat/skatter/forsakringar/avkastningsskattpautlandskalivforsakringar/nedsattavkastningsskatt.4.1a098b721295c544e1f800027816.html"
        target="_blank"
        rel="noreferrer"
      >
        {" "}
            https://skatteverket.se/privat/skatter/forsakringar/avkastningsskattpautlandskalivforsakringar/nedsattavkastningsskatt.4.1a098b721295c544e1f800027816.html{" "}
      </a>
    </p>
  </>
    ,
    table2_header_1: `Under 9.1 i deklarationen fylls skatteunderlaget i, vilket för ${v.year} är`,
    table2_header_2:
      'Under "Övriga upplysningar" i deklarationen begärs nedsättning med betald stämpelskatt om',
    tax_table_title2: "Summering av uppgifter som ska deklareras*",
    tax_table_title3: "Indikativa uträkningar*",
    premiums_half_end_tooltip:
      "Premier som betalas under juli till december räknas bara med till hälften.",
    capital_base_tooltip:
      "Kapitalunderlaget motsvarar försäkringens värde vid beskattningsårets ingång ökat med årets premiebetalningar, enligt beskrivningen ovan. Både inbetalningar i form av likvida medel och tillgångar räknas med.",
    interest_rate_tooltip:
      "Räntesats = Statslåneräntan vid utgången av november kalenderåret närmast före beskattningsåret + 1 procentenhet. Om statslåneräntan vid utgången av november är lägre än 0.25 procent ska kapitalunderlaget multipliceras med 1.25 procent, vilket innebär att räntesatsen i det här fallet blir 1.25%",
    tax_base_tooltip:
  <>
    Skatteunderlaget = Kapitalunderlaget * Räntesats. Skatteunderlaget
    avrundas nedåt till ett helt hundratal kronor. Läs mer om detta på
    Skatteverket hemsida:{" "}
    <a
      href="https://www4.skatteverket.se/rattsligvagledning/edition/2020.15/339070.html"
      target="_blank"
      rel="noreferrer"
    >
      https://www4.skatteverket.se/rattsligvagledning/edition/2020.15/339070.html
    </a>
  </>
    ,
    actual_tax_rate_before_tooltip:
      "Avkastningsskatt innan nedsättning motsvarar 30 % av skatteunderlaget och speglar den faktiska skatten som betalas för kapitalförsäkringen, om nedsättning kan fås för all stämpelskatt.",
    total_paid_tax_down_tooltip:
  <>
    Du har rätt att sätta ned den svenska avkastningskatten med utländsk
    skatt. Skulle den utländska skatten överstiga den svenska
    avkastningsskatten så finns möjlighet att spara det överskjutande
    beloppet till ett senare år. Vänligen observera att vare sig Quantum
    Leben AG eller Hubins kan garantera att någon nedsättning kommer att
    beviljas. Läs mer om detta på Skatteverkets hemsida:{" "}
    <a
      href="https://www4.skatteverket.se/rattsligvagledning/edition/2021.18/339082.html"
      target="_blank"
      rel="noreferrer"
    >
        https://www4.skatteverket.se/rattsligvagledning/edition/2021.18/339082.html
    </a>
  </>
    ,
    total_tax_for_coming_year_tooltip:
  <>
    Spara det överskjutande beloppet till ett senare år för att räkna av det
    mot avkastningsskatt på samma försäkring. Läs mer om detta på
    Skatteverkets hemsida:{" "}
    <a
      href="https://skatteverket.se/privat/skatter/forsakringar/avkastningsskattpautlandskalivforsakringar/nedsattavkastningsskatt.4.1a098b721295c544e1f800027816.html"
      target="_blank"
      rel="noreferrer"
    >
      https://skatteverket.se/privat/skatter/forsakringar/avkastningsskattpautlandskalivforsakringar/nedsattavkastningsskatt.4.1a098b721295c544e1f800027816.html
    </a>
  </>
    ,
    imported_client_chart_information:
  <><br/><br/>
    För er som har bytt försäkringsplattform och distributör till Hubins så
    kan ni i vissa fall se en skillnad i hur den historiska avkastningen har
    räknats ut i de båda systemen. Det beror på att den historiska datan är
    inhämtad från tidigare system och det kan även finns en viss skillnad i
    hur avkastningen beräknats i de olika systemen. Detta påverkar inte det
    faktiska försäkringsvärdet eller den faktiska avkastningen utan är
    enbart en fråga om vilken beräkningsmodell som används för att
    illustrera utvecklingen. <br />
    Historisk avkastning är ingen garanti för framtida avkastning. <br />
    Har du några frågor kan ni kontakta oss på <a href="mailto:kundservice@hubins.com">kundservice@hubins.com</a> eller <a href="tel:031-797 19 39">031-797 19 39</a>.
  </>,
    important: "Viktigt",
    important_information: "Viktig information",
    report_intro_text:
  <>
    I rapporten får ni som kund information om kostnader och avgifter som
    har samband med kapitalförsäkringen och ni kan när som helst begära en
    uppdelning per del genom att kontakta oss på{" "}
    <a
      href="mailto:kundservice@hubins.com"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@hubins.com
    </a>{" "}
    eller{" "}
    <a target="_blank" href="tel:0317971939" rel="noreferrer">
      031-797 19 39
    </a>{" "}
    eller vid övriga frågor om uträkningar osv.
  </>
    ,
    report_intro_text_ql:
  <p className="clarification">
    <strong>Viktig information</strong>
    <br />I rapporten får ni som kund information om kostnader och avgifter
    som har samband med kapitalförsäkringen. Ni kan när som helst begära en
    uppdelning per del, eller om ni har frågor kring rapporten, genom att
    kontakta oss på{" "}
    <a
      href="mailto:kundservice@quantumleben.se"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@quantumleben.se
    </a>{" "}
    eller{" "}
    <a href="tel:0317971939" target="_blank" rel="noreferrer">
      031-797 19 39
    </a>
    .
  </p>
    ,
    report_intro_text_ql_report:
  <p className="clarification">
    <strong>Viktig information</strong>
    <br />
    Ni kan när som helst begära en uppdelning per del, eller om ni har
    frågor kring rapporten, genom att kontakta oss på{" "}
    <a
      href="mailto:kundservice@quantumleben.se"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@quantumleben.se
    </a>{" "}
    eller{" "}
    <a href="tel:0317971939" target="_blank" rel="noreferrer">
      031-797 19 39
    </a>
    .
  </p>
    ,
    report_intro_text_hubins:
  <p className="clarification">
    <strong>Viktig information</strong>
    <br />I rapporten får ni som kund information om kostnader och avgifter
    som har samband med kapitalförsäkringen och ni kan när som helst begära
    en uppdelning per del genom att kontakta oss på{" "}
    <a
      href="mailto:kundservice@quantumleben.se"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@hubins.com
    </a>{" "}
    eller{" "}
    <a target="_blank" href="tel:0317971939" rel="noreferrer">
      031-797 19 39
    </a>
    . Vänligen läs disclaimern till respektive del av årsrapporten för mer
    information om beräkningarna bakom årsrapporten och dess innehåll. Ni
    kan även kontakta oss vid övriga frågor om uträkningar.
  </p>
    ,
    report_intro_disclaimer:
  <>
    <p className="clarification">
      Hubins vill även göra dig uppmarksam på följande: <br />
      När pengar investeras i olika investeringar förväntas investeringarna
      att utvecklas i värde under investeringsperioden. Dessa investeringar
      förväntas också medföra vissa avgifter och kostnader. Vissa av dessa
      avgifter och kostnader är relaterade till investeringsprodukten och
      vissa andra är relaterade till försäkringstjänsten. Avgifter och
      kostnader relaterade till försäkringstjänsten kan vara i form av både
      engångsavgifter, fasta eller rörliga avgifter.
    </p>
  </>
    ,
    report_intro_disclaimer_1:
  <>
    <p className="clarification">
      Vänligen notera att förväntad avkastning ger inte garanti till
      framtida avkastning. Det finns också olika sätt att mäta avkastningen
      på en investering. Investerade pengar kan både öka och minska i värde
      och alla investeringar kunder gör sker på egen risk. Värderingen av
      alla tillgångar och investeringar görs av försäkringsbolaget Quantum
      Leben AG. Hubins AB påverkar inte tillgångarnas eller investeringarnas
      värde. Hubins AB ger inte heller någon form av skatterådgivning och en
      försäkringstagare som har en utländsk kapitalförsäkring får själv
      redovisa skatteunderlaget i sin inkomstdeklaration.
    </p>
    <p className="clarification">
      Årsrapporten har för avsikt att informera om utvecklingen av diverse
      investeringar i försäkringen samt ge en översiktlig bild av alla
      försäkringsrelaterade avgifter och kostnader som har tillkommit under
      året.
    </p>
    <p className="clarification">
      Årsrapporten inleds med en graf som visualiserar den övergripande
      avkastningen under den valda tidsperioden. Här anges avkastningen i
      procent på den vertikala axeln och den horisontella axeln visar
      tidsperioden.
    </p>
  </>
    ,
    insurance_fees_table_2_intro: `Hur har kapitalförsäkringens avkastning påverkats av försäkringsavgifterna och försäkringskostnaderna under vald period?`,
    unit_price: "Pris per enhet",
    repurchase_value: "Totalt återköpsvärde",
    "promissory note": "Direktlån",
    janoojun: "Insättningar Jan-Jun",
    jultodec: "Insättningar Jul-Dec",
    "premium security": "Premieinsättning - Värdepapper",
    charge: "Transaktionsavgift",
    tax: "Stämpelskatt",
    "management fee ifa": "Rörlig avgift - Försäkringsdistribution",
    "management fee ql": "Rörlig avgift - Försäkringsbolag",
    "management fee ql2": "Rörlig avgift - Utkontraktering",
    "fixed policy cost ql": "Fast avgift - Försäkringsbolag",
    "fixed policy cost ql2": "Fast avgift - Utkontraktering",
    "risk premium": "Riskpremie- Försäkringsbolag",
    "death payment": "Dödsutbetalning",
    "deposit - repayment": "Återbetalning - Likvider",
    "deposit - correction": "Korrigering",
    "dividend as shares": "Utdelning - Andelar",
    exchange: "Konvertering",
    "exchange (issue)": "Konvertering",
    expire: "Förfall",
    "fee correction": "Avgiftskorrigering",
    issue: "Emission",
    mature: "Återbetalning",
    "repayment correction": "Korrigering - Återbetalning",
    split: "Split",
    subscription: "Teckningsrätt",
    "subscription ©": "Teckningsrätt",
    "subscription rights issue ©": "Utfärdande - Teckningsrätt",
    surrender: "Avslut",
    "surrender sec": "Uttag - Värdepapper",
    "withdrawal - buy": "Köp - Kontanter",
    "withdrawal correction": "Korrigering - Uttag",
    "withdrawal sec": "Uttag - Värdepapper",
    "capital return": "Återbetalning",
    "issue - new": "Kommande investeringar",
    "issue - marketing": "Kommande investeringar",
    "issue - on sale": "Primärmarknad",
    "issue - closed": "Utkast",
    "issue - secondary market": "Andrahandsmarknad",
    "issue - matured": "Handla",
    password_length_validation: "Ditt lösenord måste minst inehålla 6 tecken",
    repeat_password_validation:
      "Det repeterade lösenorder matchar inte orginalet",
    common_error_validation: "Något gick fel. Vänligen försök igen.",
    password: "Lösenord",
    email_password_validation_error:
      "Användarnamnet eller lösenordet är felaktigt",
    tfa_validation_error: "Koden är fel, eller så har sessionen gått ut. Testa igen eller starta om login",
    activation_success: "Du kan nu logga in med ditt nya lösenord",
    activation_success2: "Nu kan du logga in för att se din årsrapport",
    to_login: "Till login",
    something_went_wrong_activation_title: "Något gick fel",
    something_went_wrong_activation_text:
  <p>
    Vänligen försök igen eller kontakta oss på{" "}
    <a
      href="mailto:kundservice@quantumleben.se"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@quantumleben.se
    </a>{" "}
    eller{" "}
    <a target="_blank" href="tel:031-797 19 39" rel="noreferrer">
      031-797 19 39
    </a>
  </p>
    ,
    activation_no_user_found: "Något har gått fel!",
    activation_no_user_found_text:
  <p>
    Det kan vara så att du redan har registrerat ditt konto, i så fall kan
    du logga in via länken nedan eller via webbadressen{" "}
    <a href="https://quantumleben.se">quantumleben.se</a>. Om detta inte
    fungerar är du välkommen att kontakta oss på{" "}
    <a
      href="mailto:kundservice@quantumleben.se"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@quantumleben.se
    </a>{" "}
    eller{" "}
    <a target="_blank" href="tel:0317971939" rel="noreferrer">
      031-797 19 39
    </a>
  </p>
    ,
    activate_account: "Aktivera konto",
    repeat_password_label: "Repetera lösenordet",
    insurance_fees_section_1:
  <>
    <p>
      Hubins vill även göra dig uppmarksam på följande: <br />
      Den totala försäkringsavgiften och försäkringskostnaden under perioden
      beräknas som summan av alla engångsavgifter i form av
      transaktionsavgifter, den fasta löpande avgiften, den rörliga löpande
      avgiften samt riskpremien som har belastat kapitalförsäkringen
      under vald period enligt ovan. För information om tidigare år vänligen kontakta
      kundservice.
    </p>
  </>
    ,
    insurance_fees_section_2:
  <>
    <p>
      Dessa avgifter fördelas sedan i form av ersättning till samtliga
      parter, exempelvis försäkringsbolaget Quantum Leben AG eller
      försäkringsdistributören Hubins AB. Dessa avgifter och kostnader samt
      ersättningar presenteras i tabellen ”Försäkringsavgifter och
      försäkringskostnader”. Här informeras det även att Hubins AB inte
      mottar någon ersättning från annan tredjepart än Quantum Leben AG (ex.
      från fondbolag eller annat produktbolag) samt att Hubins AB inte
      tillhandahåller någon ersättning till annan tredjepart. Eventuella
      ersättningar till tidigare försäkringsdistributörer (ej Hubins) anges
      också i denna tabell.
    </p>
    <p>
      Vänligen notera att ovan beskrivning av försäkringsavgifter och
      försäkringskostnader är generellt och de faktiska
      försäkringsavgifterna och försäkringskostnaderna kan komma att skilja
      sig i procent från ovan.
    </p>
    <p>
      Tabellen nedanför har för avsikt att illustrera hur
      försäkringsavgifter och försäkringskostnader reducerar avkastningen
      för vald period enligt ovan. Här visas även den totala avkastning före och efter årets
      försäkringsavgifter och försäkringskostnader. Denna illustration ska
      sätta de totala försäkringsavgifterna och försäkringskostnaderna i
      relation till investeringens avkastning samt förtydliga hela avgift-
      och kostnadsstrukturen.
    </p>
  </>
    ,
    the_currency: "Valuta",
    username: "Användarnamn",
    liquid_account: "Likvidkonto",
    debt_account: "Skuldkonto",
    current_holdings: "Aktuellt innehav",
    // For debugging - don't translate
    test: "Test se",
    warning: "Varning",
    wish_to_change_form:
      "Om du går tillbaka för att justera tidigare svar, kommer svaren du angett i på den här sidan inte att sparas.",
    reason_for_withdrawal: "Anledning till uttag",
    "policy_application_imported_&_kyc":
      "Försäkringsuppdatering och Kundkännedom",
    forgot_password: "Glömt lösenord?",
    reset_password_error:
  <p>
    Något gick fel, vänligen försök igen eller kontakta oss på{" "}
    <a
      href="mailto:kundservice@quantumleben.se"
      target="_blank"
      rel="noreferrer"
    >
      kundservice@quantumleben.se
    </a>{" "}
    eller{" "}
    <a target="_blank" rel="noreferrer" href="tel:0317971939">
      031-797 19 39
    </a>
  </p>
    ,
    request_reset: "Återställ lösenord",
    reset_success: "Kolla din epost",
    'reset_password_success': 'Klart!',
    reset_success_text:
      "Om du har en epost registrerad hos oss ska du ha fått en länk för att återställa ditt lösenord i din inbox. Om mailet inte kommer fram kan du behöva kolla din skräppost.",
    reset_password_success_text:
      "Nu kan du logga in med ditt nya lösenord",
    reset_password_header: "Glömt lösenord",
    yearly_checkup: 'Årsuppdatering',
    repeater_error: 'Vänligen fyll i de tomma fälten',
    percent_error_message: 'Värdet får inte vara större än 100 eller mindre än 0',
    'hubins_backoffice': 'Hubins Backoffice',
    'hubins_compliance': 'Hubins Compliance',
    'quantum_backoffice': 'Quantum Backoffice',
    'quantum_compliance': 'Quantum Compliance',
    'a_policy_1': 'Policy information',
    'a_policy_2': 'Demand and needs Assesment',
    'a_policy_3': 'Know your customer',
    'a_policy_4': 'Connections',
    'a_policy_5': 'Transactions',
    'a_policy_6': 'Source of Funds',
    'a_policy_7': 'Enhanced due diligence',
    'a_policy_verdict': 'Policy approval',

    'handle_sources': 'Hantera källor',
    'sources': 'Källor',
    'new_source': 'Ny källa',

    'sof_salary': 'Överskott lön',
    'sof_property': 'Försäljning av fastighet',

    'proof_verified': 'Källa bevisad',
    'proof_provided': 'Bevis skickat för granskning',
    'proof_not_provided': 'Källa ej bevisad',
    'insufficient_transaction_amount': 'Summan av de valda källorna uppnår ej det valda beloppet av transaktionen. Du kan gå tillbaks och ändra värdet på transaktionen om du önskar sätta in ett lägre belopp.',
    'deposit_instructions_title': 'Insättningsuppgifter',
    'deposit_instructions_text': 'Logga in på din internetbank och genomför instättning med uppgifterna nedan.',
    'investment_stock': 'onoterade aktier',

    'sof_status_denied': 'Avfärdad',
    'sof_status_proof_needed': 'Bevis krävs',
    'sof_status_complete': 'Godkänd',
    'sof_status_locked': 'Låst',
    'sof_status_': '',

    'transaction_type_pre': 'Premie insättning',

    'stock_2_status': 'Genomförd',
    'stock_6_status': 'Under behandling',
    'stock_10_status': 'Tilldelning',
    'stock_8_status': 'Väntelista',
    'stock_4_status': 'Order mottagen',
    'stock_5_status': 'Order mottagen',
    'stock_2_text': 'Investering genomförd - Aktier inbokade',
    'stock_6_text': ' ',
    'stock_10_text': 'Ni har fått tilldelning - Se till att ha likvid tillgängligt',
    'stock_8_text': 'Väntelista - Ingen tilldelning',
    'stock_4_text': 'Order mottagen - Inväntar tilldelning',
    'stock_5_text': 'Order mottagen - Inväntar tilldelning',
    'stock_1_text': 'Ni har fått tilldelning - Se till att ha likvid tillgängligt',
    'stock_1_status': 'Tilldelning',

    insurance_number: 'Försäkringsnummer',
    company: 'Bolag',
    product: 'Produkt',
    unlist: 'Onoterad',
    stock_list: 'Noterad aktie',
    stock_unlist: 'Onoterad aktie',
    investment_knowledge_test_title: 'Passandeprövning - Onoterade aktier',
    tfa_code: 'Kod',
    tfa_verify: 'Verifiera kod',
    tfa_required_title: 'Aktivera tvåstegsverifiering',
    tfa_required_text: 'Vi kommer inom kort kräva att alla aktiverar tvåstegsverifiering för att kunna fortsätta använda tjänsterna.',
    tfa_required_text_2: 'Gå till inställningar för att aktivera tvåstegsverifiering.',
    settings: "Inställningar",
    user_documents: 'Användarens dokument',
    portfolio_documents: 'Portföljens dokument',
    client: 'Klient',
    ssn_org_num: 'Pers/Org-nummer',
    distributor: 'Distributör',
    updated_at: 'Senast uppdaterad',
    view: 'Se mer',
    a_summary: 'Summering',
    register_insurance: 'Kapitalförsäkring',
    ongoing_insurance: 'Påbörjad registrering',
    register_insurance_title: 'Teckna en ny kapitalförsäkring',
    register_insurance_title_new: 'Kapitalförsäkringen för alla investeringar',
    register_insurance_text: 'Hos oss kan du samla och hantera hela ditt innehav under ett och samma tak. Hubins säkerställer att du har behov av en kapitalförsäkring och om du tjänar på att hålla dina investeringar hos oss.',
    register_insurance_summary_text: 'Här får du en översikt av den pågående försäkringsansökan och de olika stegen som behöver genomföras för att kapitalförsäkringen ska öppnas. Att teckna en försäkring är kostnadsfritt. Avgifter tillkommer först i samband med att du gör din första insättning.',
    almost_done_registration: 'Utforska nya investeringar, öppna kapitalförsäkring och flytta in dina befintliga investeringar för att samla allt på en plattform.',
    started_registration: 'Påbörjad registrering',
    start_registration_desc: 'Få tillgång till vår flexibla kapitalförsäkringslösning - optimerad för onoterade och alternativa investeringar.',
    p_kt_start: "Kunskapstest",
    personnel_registration: 'Kundkännedom och signering av fullmakt',
    holdings: 'Innehav',
    code: 'Kod',
    solve_price: 'Lösenpris',
    option: 'Optioner',
    p_presale: 'Förköpsinformation',
    cryptocurrency: 'Kryptotillgångar',
    faq_stock_order_title: "Viktiga Upplysningar",
    faq_crypto_order_title: "Viktiga Upplysningar",
    faq_crypto_order:
    <>
      <p>Nedan pajdiagram har för avsikt att illustrera hur avgifter reducerar den förväntade avkastningen under investeringsperioden. Tabellen nedanför visar vilka typer av avgifter denna investering medför samt vad den totala förväntade avkastningen för hela investeringsperioden beräknas vara efter avgifter.</p>
      <p>Vänligen notera att beräkningarna som resulterade i tabellen och pajdiagrammet är baserade på ett antal antaganden samt begränsningar. Exempel på där antaganden är gjorda är förväntad avkastning och investeringsperiod. Hubins reserverar sig även för eventuella felräkningar.</p>
      <p>När du investerar dina pengar i kryptotillgångar förväntas ditt kapital att öka eller minska i värde under investeringssperioden. Du förväntas också betala vissa avgifter för att kunna ta del av den försäkringsbaserade investeringsprodukten. Vissa av dessa avgifter är relaterade till investeringsprodukten och vissa andra är relaterade till försäkringstjänsten. Dessa avgifter kan vara i form av både engångsavgifter, löpande avgifter, fasta eller rörliga avgifter. Här ser du ett estimat på hur mycket den totala förväntade avkastningen kommer att påverkas av totala avgifter som kommer att tas ut i investeringsprodukten och/eller i försäkringen. Detta ska hjälpa dig att sätta de totala avgifterna i relation till investeringens förväntade avkastning samt hjälpa dig att förstå hela avgiftstrukturen.</p>
      <p>Vänligen notera att beräkningarna baseras på den enskilda investeringens förväntade avkastning och att investeringen behålls i 1 till 10 år. Den beräknade kapitaltillväxten uppnås därmed med hjälp av ränta-på-ränta-effekten där den årliga förväntade avkastningen först omvandlas till en månatlig räntesats. Ränta-på-ränta-effekten resulterar sedan i en exponentiell utveckling av dina investerade pengar där du även får avkastning på den avkastning som genererats föregående månad. Detta skiljer sig avsevärt från en linjär utveckling där avkastningen i kronor är lika stor varje månad.</p>
      <p>I detta exempel växer investeringen med en viss förväntad avkastning per år, vilket innebär att även den rörliga försäkringsavgiften och försäkringens riskpremie samt produktens förvaringsavgift växer i samma takt under investeringsperioden. Dessa avgifter baseras här på investeringens värde vid slutet av varje månad men dras ej från försäkringens ingångsvärde för nästa månad. Vänligen observera att produktavgifter i form av engångsavgifter (köpavgift) baseras i exemplet på investeringens pris.</p>
      <h5>Produktavgifter</h5>
      <p>Engångsavgifter: Ersättning till Tjänsteleverantör, i detta fall Safello AB, vid köp av kryptotillgångar. Engångsavgifter tas vanligtvis ut i början av din investering.</p>
      <p>Löpande avgifter: Produktens förvaringsavgift om 0.5% per år som dras månadsvis från saldot av kryptotillgångarna. Tjänsteleverantören, i detta fall Safello AB, erhåller 100% av denna avgift.</p>
      <h5>Försäkringsavgifter</h5>
      <p>Engångsavgifter: Försäkringens transaktionsavgifter för köp och sälj av värdepapper. Hubins AB erhåller 30% av den transaktionsavgift som betalas till Quantum Leben AG för outsourcing av Quantums tjänster. Denna avgift tas ut i början av din investering vid köp.</p>
      <p>Löpande avgifter: Den rörliga avgiften syftar till den rörliga ersättningen som baseras på försäkringsvärdet vid slutet av varje månad och dras kvartalsvis. Hubins AB erhåller i sin roll som försäkringsdistributör 30% av de rörliga ersättningen som betalas till Quantum Leben AG. Hubins AB erhåller även ytterligare 35% av den rörliga ersättningen som betalas till Quantum Leben AG för utkontraktering av Quantums tjänster som inkluderar men är inte begränsad till kundtjänstärenden, support avseende försäkringsadministration, förberedelse för hantering av försäkringsfall, IT-support etc.</p>
      <p>Den fasta avgiften syftar till en fast årlig ersättning som dras kvartalsvis från försäkringsvärdet. Denna avgift motsvarar 1800 svenska kronor och tillkommer endast om du väljer att investera i eller hålla onoterade obligationer och direktlån samt noterade obligationer. Den fasta avgiften baseras här på den andel som investeringen utgör i hela försäkringen. Vid investeringar i utländska valutor omvandlas denna avgift enligt dagens kurs. Uträkningarna tar därför inte hänsyn till eventuella valutakursändringar under investeringsperioden. Hubins AB erhåller 61,11% av den fasta avgiften som betalas till Quantum Leben AG för utkontraktering av vissa administrativa tjänster till Hubins.</p>
      <p>För kunder över 60 år tillkommer även en riskpremie enligt dokumentet “Kostnader och Avgifter - Hubins och Quantum Leben” för att täcka kapitalförsäkringens återbetalningsskydd. Vid inträffande av försäkringsfall kommer denna avgift att finansiera den extra procenten av försäkringsvärdet som betalas ut vid dödsfall. I uträkningarna baseras riskpremien på den livförsäkrades ålder per idag.</p>
      <p>Vänligen notera att förväntad/prognostiserad avkastning inte ger någon garanti för framtida avkastning och att dessa beräkningar enbart kan stämma med verkligheten/faktiska utfall om alla förutsättningar och antaganden uppfylls. Pajdiagramet och tabellen är till för att hjälpa dig sätta de totala produkt- och försäkringsavgifterna i relation till den förväntade avkastningen för hela investeringsperioden och visa hur dessa påverkar avkastningen. Investerade pengar kan både öka och minska i värde och det finns aldrig några garantier för att du/ni återfår hela eller delar av det investerade kapitalet. Alla investeringar du/ni som kund gör sker på din/er egen risk.</p>
    </>,
    abort_purchase: 'Avbryt order',
    investment_cryptocurrency: 'Kryptotillgångar',
    other: 'Övrigt',
    crypto: 'Kryptotillgångar',
    end_date: 'Slutdatum',
    cufe: 'Förvarningsavgift',
    va: "Värdejustering",
    subs: 'Teckningsrätter',
    subsc: 'Teckningsrätter',
    feecorr: 'Avgiftskorrigering',
    bankfee: "Bankkostnad",
    transfer: 'Överför',
    easier_declaration: 'Enklare deklaration',
  },
});

export default keys;
